import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./header/Header";
import Footer from "./footer/Footer";
// import SubHeader from "./subHeader/SubHeader";

const Layout = () => {
  return (
    <>
      <Header />
      {/* <SubHeader /> */}
      <Outlet /> {/* This is where each page will be injected */}
      <Footer />
    </>
  );
};

export default Layout;
